import styled from 'styled-components';

export const IconContainer = styled.span`
  vertical-align: super;
  margin-right: 5px;
`;
